import { DecimalPipe } from '@angular/common';
import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'dynamicDecimal',
  pure: false,
  standalone: true
})
export class DynamicDecimalPipe implements PipeTransform {
  locale = inject(LOCALE_ID);

  transform(value: string | number, format?: string): string | number {
    try {
      const decimalPipe = new DecimalPipe(this.locale);
      return decimalPipe.transform(
        this.normalizeValue(value),
        format ?? this.getDecimalNumbersByValue(typeof value === 'number' ? value.toString() : (value as string))
      );
    } catch (e) {
      console.error(e);
      return value as string | number;
    }
  }

  private normalizeValue(value: string | number) {
    if (typeof value === 'number') return value;

    // Convert number strings with German formatting to ensure the pipe can handle them
    return value?.includes(',') ? value.replace(',', '.') : value;
  }

  private getDecimalNumbersByValue(value: string) {
    const decimals = value?.includes('.') ? value.split('.')[1].length : 0;

    return !decimals ? null : `1.${decimals}-${decimals}`;
  }
}
